import React from 'react';

const MenuCustom = React.lazy(() => import("@/pages/admin/menu/MenuCustom"));
const MemberCustom = React.lazy(() => import("@/pages/admin/member/MemberCustom"));
const FindGameCustom = React.lazy(() => import("@/pages/admin/find/FindCustomPage"));

export const AdminRoute = [
    { path: "/menuCustom", element: <MenuCustom />, requiredRoles: ['svip'] },
    { path: "/memberCustom", element: <MemberCustom />, requiredRoles: ['svip'] },
    { path: "/findGameCustom", element: <FindGameCustom />, requiredRoles: ['svip'] },
];
